import React, { Component } from 'react';
import { HeaderSub } from '../../Common/HeaderSub'
import { BasketList } from './BasketList';
import { Big3Common } from '../../../js/IncludeManager'

/* 개발담당:양유빈
 * 화면기능:플랫폼 메인 페이지
 * 세부설명:
*/

export class Index extends Component {
    static displayName = Index.name;

    constructor(props) {
        super(props);
        this.state = {
            RenderName: this.CompName.BasketList,  //기본 컴포넌트 할당
            ContentState: null
        };
    }
    //호출할 컴포넌트 이름
    CompName = {
        "BasketList": "BasketList"
    }
    //초기화
    componentDidMount() {
    }
    componentWillUnmount() {
        Big3Common.HistoryBackToClearBackdoor();
    }
    renderPick() {
        if (this.state.RenderName === this.CompName.BasketList) {
            return (
                <div>
                    <HeaderSub
                        LinkUrl={"/"}
                        HeaderTitle="장바구니"
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                    />
                    <BasketList
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                    />
                </div>
            );
        }
        else {
            return (
                <div>
                    페이지가 없습니다
                </div>
            )
        }
        
    }
    render() {
        let RnderAct = this.renderPick();
        return (
            <div>
                {RnderAct}
            </div>
        );
    }
}
